import { Module } from "vuex-smart-module"

import TargetsState from "./state"
import TargetsMutations from "./mutations";
import TargetsGetters from "./getters";
import TargetsActions from "./actions"

export const targetsModule = new Module({
    state: TargetsState,
    getters: TargetsGetters,
    mutations: TargetsMutations,
    actions: TargetsActions
})